<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :filterOfZones="true"
              :filterOfSubZones="true"
              @filter="validateFilter"
              @showHideLoading="showHideLoading"
              classZones="col-12 col-md-6 col-xl-2"
              classSubZones="col-12 col-md-6 col-xl-2"
              classFarms="col-12 col-md-6 col-xl-3"
              classLots="col-12 col-md-6 col-xl-2"
              ref="filters"
            >
              <template slot="prev">
                <select-component
                  :class="`col-12 col-md-6 col-xl-3 mt-3`"
                  :dataOptions="inspections"
                  :labelSelect="`${$t('common_words.evaluations')}: *`"
                  :initialSelection="dataFilter.inspectionId"
                  :isMultiple="false"
                  :requireClass="`required-inspection`"
                  @onChange="handleChangeSelected"
                  modelName="inspectionId"
                />
              </template>
              <template slot="after-lot">
                <select-component
                  v-if="showCalculationTypeSelect"
                  :class="`col-12 col-md-6 col-xl-3 mt-3`"
                  :dataOptions="getCalculationType"
                  :labelSelect="`${$t('audit.calculation_type')}:`"
                  :initialSelection="dataFilter.calculationType"
                  :isMultiple="false"
                  @onChange="handleChangeSelected"
                  modelName="calculationType"
                />
                <select-component
                  :class="`col-12 col-md-6 col-xl-3 mt-3`"
                  :dataOptions="getCalculationTypeNA"
                  :labelSelect="`${$t('audit.calculate_na')}:`"
                  :initialSelection="dataFilter.calculationTypeNA"
                  :isMultiple="false"
                  @onChange="handleChangeSelected"
                  modelName="calculationTypeNA"
                />
              </template>
              <template v-if="haveRangeColor" slot="after-lot">
                <div :class="`col-12 col-md-6 col-xl-3 mt-3`">
                  <label for="">{{ $t('common_words.color_range') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    @change="handleRangeColor(range_color_select)"
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-range_color_select"
                    v-model="range_color_select"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in rangeColorsByModule"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <card :showHr="false" id="chart" v-show="showChart">
          <div class="row">
            <div class="col-12">
              <RangeColorLegend
                :haveRangeColor="haveRangeColor"
                :rangeColor="range_color_select_data"
                :isPercentage="true"
                :haveNAByComplianceChart="
                  dataFilter.calculationTypeNA == 'calculation_with_na'
                "
              ></RangeColorLegend>
              <highcharts ref="chartRef" :options="chartOptions"></highcharts>
            </div>
          </div>
        </card>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { isset } from 'src/util/Util.js';
import { Pagination as LPagination } from 'src/components/index';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import Legend from 'src/views/Pages/Dashboard/AdvancedAudit/ComplianceChart/Legend.vue';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import RangeColorLegend from 'src/components/RangeColorLegend.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    highcharts: Chart,
    [Filter.name]: Filter,
    LPagination,
    Legend,
    RangeColorLegend,
  },

  data() {
    return {
      activeName: 'filter',
      dataFilter: {
        farm: [],
        lot: [],
        inspectionId: null,
        calculationType: 'without_lot_area',
        calculationTypeNA: 'calculation_without_na',
      },
      valueCollapse: null,
      inspections: [],
      chartOptions: {},
      showChart: false,
      showCalculationTypeSelect: false,
      haveData: false,
      range_color_select: null,
      range_color_select_data: null,
      haveRangeColor: false,
    };
  },

  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    calculationTypes() {
      return this.concatAll([
        {
          id: 'without_lot_area',
          name: this.$t('common_words.without_lot_area'),
        },
        {
          id: 'includes_na_value',
          name: this.$t('common_words.includes_na_value'),
        },
      ]);
    },
    getCalculationType() {
      return [
        { id: 'without_lot_area', name: i18n.t('audit.without_lot_area') },
        { id: 'with_lot_area', name: i18n.t('audit.with_lot_area') },
      ];
    },
    getCalculationTypeNA() {
      return [
        {
          id: 'calculation_without_na',
          name: i18n.t('audit.calculation_without_na'),
        },
        {
          id: 'calculation_with_na',
          name: i18n.t('audit.calculation_with_na'),
        },
      ];
    },
  },

  mixins: [MixinMasters, MixinMenu, MixinPermissions, MixinCharts],

  methods: {
    handleChangeSelected(data) {
      if (data.name === 'inspectionId') {
        const selectedInspection = this.inspections.find(
          (inspection) => inspection.id === data.selects
        );

        this.showCalculationTypeSelect =
          selectedInspection && selectedInspection.catch_type === '1';
      }
      this.$set(this.dataFilter, data.name, data.selects);
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleRangeColor(rengeColorId) {
      if (!isset(this.range_color_select)) {
        this.showChart = false;
      }
      this.range_color_select_data = this.rangeColorsByModule.find(
        (range) => range.id == rengeColorId
      );
    },
    validateFilter(data) {
      this.showHideLoading(true);
      this.showChart = false;
      this.dataFilter = { ...this.dataFilter, ...data };

      return this.$validator.validateAll().then((responseSelects) => {
        if (!responseSelects) return responseSelects;
        if (!isset(this.dataFilter.inspectionId)) {
          this.showHideLoading();

          return this.validationInputsRequired('inspection');
        } else {
          this.getReport();

          return true;
        }
      });
    },

    getReport() {
      const data = {
        ...this.dataFilter,
        route: 'advanced/audits/compliancechart',
        rangeColorSelect: this.range_color_select_data,
      };
      Axios.postMasters(data)
        .then((response) => {
          if (response.data.values.data.length > 0) {
            this.showChart = true;
            try {
              this.resetDrilldown('chartRef');
              this.chartOptions = this.columns(
                response.data,
                true,
                i18n.t('common_words.compliance'),
                '500',
                false,
                true
              );
              this.chartOptions.lang = {
                drillUpText: `${i18n.t(
                  'common_words.return_to'
                )} {series.name}`,
              };
            } catch (error) {
              console.log('error: ', error);
            }
          } else {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },
  created() {
    if (this.isIndex()) {
      const urlModule = sessionStorage.getItem('urlModule');
      let data = {};
      data.route = 'rangecolorheaders/reports';
      data.urlModule = urlModule.replace(/^\/+/, '');
      Promise.all([
        Axios.getMasters('advanced/audits/inspections'),
        Axios.postMasters(data),
      ])
        .then(([response_inspections, response_range_colors]) => {
          this.inspections = response_inspections.data.data;
          this.rangeColorsByModule = response_range_colors.data.data;
          if (this.rangeColorsByModule.length) {
            const rangeLenghts = this.rangeColorsByModule.length;
            if (rangeLenghts >= 1) {
              this.haveRangeColor = true;
              this.range_color_select = this.rangeColorsByModule[0].id;
              this.range_color_select_data = this.rangeColorsByModule[0];
            }
          }
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('advanced');
  },
  destroyed() {
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
